import React from 'react'
import { Stack, Group, Box, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import { router } from '@inertiajs/react'
import dayjs from 'dayjs'
import { ReferredReview } from '../../../../types'
import Note from '../../../../components/Note'

export const ReferredReviewsTable = (props: { reviews: ReferredReview[] }) => {
  const { reviews } = props
  if (reviews.length === 0) {
    return (
      <Text size="sm" c="dimmed" fs="italic">Aucun avis parrainé par cet avis.</Text>
    )
  }
  return (
    <Stack gap="xs">
      {reviews.map((r) => (
        <Group
          key={r.id} justify="space-between" wrap="nowrap"
          onClick={() => router.visit(`/admin/reviews/${r.id}`)}
          style={{ padding: '8px 10px', borderRadius: 6, background: 'var(--mantine-color-gray-0)', cursor: 'pointer' }}
        >
          <Box style={{ width: 20 }}>
            {r.same_ip && <IconAlertTriangle size={16} color="var(--mantine-color-orange-6)" />}
          </Box>
          <Text size="sm" style={{ flex: 1 }}>
            {r.vehicle_version?.brand?.title} {r.vehicle_version?.modele}
          </Text>
          <Note note={r.note} size="small" />
          <Text size="xs" c="dimmed" style={{ minWidth: 90, textAlign: 'right' }}>
            {dayjs(r.created_at).format('DD/MM/YYYY')}
          </Text>
        </Group>
      ))}
    </Stack>
  )
}
